import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import axios from 'axios';

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

interface GoogleSignInProps {
    onSuccess: (token: string) => void;
    onError?: (error: string) => void;
}

export function GoogleSignInButton({ onSuccess, onError }: GoogleSignInProps) {
    const handleSuccess = async (credentialResponse: any) => {
        try {
            // Send Google credential to backend
            const response = await axios.post(`${API_URL}/api/auth/google`, {
                credential: credentialResponse.credential
            });

            // Store JWT token
            const token = response.data.access_token;
            localStorage.setItem('access_token', token);
            
            // Trigger storage event for useAuth hook to pick up
            window.dispatchEvent(new Event('storage'));
            
            // Call success callback immediately
            onSuccess(token);
        } catch (error: any) {
            console.error('Google OAuth failed:', error);
            const errorMessage = error.response?.data?.detail || 'Google sign-in failed. Please try again.';
            if (onError) {
                onError(errorMessage);
            } else {
                alert(errorMessage);
            }
        }
    };

    const handleError = () => {
        console.error('Google Login Failed');
        if (onError) {
            onError('Google sign-in was cancelled or failed');
        }
    };

    if (!GOOGLE_CLIENT_ID) {
        return (
            <div className="text-red-600 text-sm p-3 bg-red-50 rounded">
                Google OAuth not configured. Please set VITE_GOOGLE_CLIENT_ID in .env.local
            </div>
        );
    }

    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <div className="flex justify-center">
                <GoogleLogin
                    onSuccess={handleSuccess}
                    onError={handleError}
                    text="signin_with"
                    shape="rectangular"
                    theme="outline"
                    size="large"
                    width="100%"
                />
            </div>
        </GoogleOAuthProvider>
    );
}
